import { useCommonUserProfile, useUserProfile } from '@hooks/user';
import { signOut } from '@apis/auth';

export default function useLogout() {
  const { mutate: mutateUserProfile } = useCommonUserProfile();
  const { mutate: mutateCreatorProfile } = useUserProfile();

  const logout = async () => {
    await signOut();
    await Promise.all([mutateUserProfile(), mutateCreatorProfile()]);
  };

  return logout;
}
